import React, {useEffect, useState} from 'react';
import { Rating } from 'react-simple-star-rating'

interface ReviewItemProps {
	rate: number,
	text: string,
}

const ReviewItem = (props: ReviewItemProps) => {
	const [width, setWidth]   = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	return (
		<div className="reviewItem">
			<div className="reviewItem__rating">
				<Rating
					initialValue={props.rate}
					readonly={true}
					size={width > 1439 ? 24 : 18}
					fillColor={"#F37021"}
				/>
			</div>
			<div className="reviewItem__text">
				<span>{props.text}</span>
			</div>
		</div>
	);
};

export default ReviewItem;